import {is_function} from '../../../../Helpers/js/simple.functions';
import $ from 'jquery';
import UI from '../../0-ui';

export class RankingGroup {
  constructor(rankingNode, onChangeFunc) {
    this.onChangeFunc = onChangeFunc;
    this.domNode = rankingNode;

    UI.onHideEvent(this.onChangeFunc);
    UI.onShowEvent(this.onChangeFunc);

    this.enableKeyHandling();
    this.enableDragAndDrop();
  }

  enableDragAndDrop() {
    var $list = $(this.domNode);
    if ($list.length == 0) return;

    // Safe delete for jQuery UI 1.8.5
    try {
      $list.sortable('destroy');
    } catch {}

    $list.sortable({
      scroll: false,
      axis: 'y',
      revert: false,
      dropOnEmpty: false,
      forceHelperSize: true,
      forcePlaceholderSize: true,
      cursor: 'move',
      opacity: 1,
      items: 'li',
      tolerance: 'intersect',
      placeholder: 'ranking-placeholder',

      start: (e) => e.originalEvent.target.focus({focusVisible: false}),
      stop: (e) => {
        e.originalEvent.target.focus({focusVisible: false});
        this.triggerOnChange();
      },
    });
  }

  enableKeyHandling() {
    var rankingOptions = Array.from(this.domNode.querySelectorAll('.ranking-option'));
    rankingOptions.map((rankingOption) => {
      rankingOption.addEventListener('keydown', this.keyDownHandler.bind(this));
      rankingOption.addEventListener('click', (e) => this.clickHandler(e, rankingOption));
    });
  }

  clickHandler(e, node) {
    var targetTagname = event.target.tagName.toUpperCase();
    if (targetTagname != 'INPUT' && targetTagname != 'TEXTAREA') {
      node.focus({focusVisible: false});
    }
  }

  keyDownHandler(event) {
    var next = false;
    var node = event.currentTarget;

    switch (event.key) {
      case 'Down':
      case 'ArrowDown':
      case 'Right':
      case 'ArrowRight':
        next = node.nextElementSibling;
        if (!next) break;
        node.parentNode.insertBefore(next, node);
        break;

      case 'Up':
      case 'ArrowUp':
      case 'Left':
      case 'ArrowLeft':
        next = node.previousElementSibling;
        if (!next) break;
        node.parentNode.insertBefore(next, node.nextElementSibling); //workaround für ein nicht unterstütztes "insertAfter", damit Focus auf dem aktuellen node bleibt
        break;

      default:
        break;
    }

    this.triggerOnChange();
  }

  triggerOnChange() {
    if (is_function(this.onChangeFunc)) {
      this.onChangeFunc('userchange');
    }
  }
}
